<div *ngIf="validationMessages.length" [ngClass]="{'form-validation': true, floating: floating}">
  <p *ngFor="let message of validationMessages" [innerHTML]="message"></p>
</div>
